"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.startTime = void 0;
function startTime(utils) {
    var loadPrimaryInput = utils.loadPrimaryInput;
    it('Should start with value of 08:30 PM', function () {
        loadPrimaryInput().should('have.value', '08:30 PM');
    });
}
exports.startTime = startTime;
